export enum PathType {
  UNDEFINED = '',
  HOUSING_SOLIDARITY = 'HS',
  HOUSING_PARIS = 'HP',
  HOUSING_TOURCOING = 'HT',
  HOUSING = 'HC',
  HOUSING_LILLE = 'HL',
  HOUSING_GRENOBLE = 'HG',
  HOUSING_CRETEIL = 'HR',
  HOUSING_ETUDIANTE = 'HE',
  HOUSING_MARSEILLE = 'HA',
  HOUSING_BAILLEURS_SOCIAUX = 'BS'
}

export const isPathType = (pathType: string | null): pathType is PathType => {
  switch (pathType) {
    case PathType.HOUSING:
    case PathType.HOUSING_PARIS:
    case PathType.HOUSING_TOURCOING:
    case PathType.HOUSING_LILLE:
    case PathType.HOUSING_SOLIDARITY:
    case PathType.HOUSING_GRENOBLE:
    case PathType.HOUSING_CRETEIL:
    case PathType.HOUSING_MARSEILLE:
    case PathType.HOUSING_ETUDIANTE:
    case PathType.HOUSING_BAILLEURS_SOCIAUX:
      return true;
    default:
      return false;
  }
};
